import {
	RiArrowDownLine,
	RiArrowLeftLine,
	RiArrowRightLine,
	RiArrowUpLine,
} from "@remixicon/react";
import { cn } from "@/lib/utils";

export interface SortToggleProps {
	ascending: boolean;
	onClick: () => void;
	className?: string;
	ascendingTitle?: string;
	descendingTitle?: string;
	isHorizontal?: boolean;
}

export const SortToggle = function SortToggleComponent({
	ascending,
	onClick,
	className,
	ascendingTitle = "Sort earliest first",
	descendingTitle = "Sort latest first",
	isHorizontal = false,
}: SortToggleProps) {
	return (
		<button
			type="button"
			onClick={onClick}
			className={cn(
				"flex h-9 w-9 items-center justify-center rounded-xl transition-colors active:scale-[0.99]",
				ascending
					? "bg-primary text-primary-foreground"
					: "border border-input bg-background text-foreground hover:bg-accent",
				className,
			)}
			title={ascending ? ascendingTitle : descendingTitle}
		>
			{isHorizontal ? (
				ascending ? (
					<RiArrowRightLine className="h-4 w-4" />
				) : (
					<RiArrowLeftLine className="h-4 w-4" />
				)
			) : ascending ? (
				<RiArrowDownLine className="h-4 w-4" />
			) : (
				<RiArrowUpLine className="h-4 w-4" />
			)}
		</button>
	);
};
